export const HR_DEPARTMENT_PERMISSION_CODES = {
    WEB_HR_DEPARTMENT_LIST: 'WEB_HR_DEPARTMENT_LIST',
    WEB_HR_DEPARTMENT_DETAIL: 'WEB_HR_DEPARTMENT_DETAIL',
    WEB_HR_DEPARTMENT_ADD: 'WEB_HR_DEPARTMENT_ADD',
    WEB_HR_DEPARTMENT_EDIT: 'WEB_HR_DEPARTMENT_EDIT',
    WEB_HR_DEPARTMENT_DELETE: 'WEB_HR_DEPARTMENT_DELETE',
    WEB_HR_DEPARTMENT_IMPORT: 'WEB_HR_DEPARTMENT_IMPORT',
    WEB_HR_DEPARTMENT_EXPORT: 'WEB_HR_DEPARTMENT_EXPORT',
} as const;

